const BOM = '﻿';
// const BOM = 'K';
export default BOM;
